import React, { useEffect } from "react";
import CartItem from "./item";
import EmptyCart from "./empty-cart";
import { removeCartItems } from "actions/cart";
import { trackViewCart, trackRemoveFromCart } from "services/analytics";
import { useSelector, useDispatch } from "react-redux";
import { useGlobalContext } from "context/global";
import ClearCart from "./clear";
import { getCartItemsSeparated, onSideProductRemoved } from "utils/cart";
import CartUpsell from "./upsell";

const CartBody = () => {
	const { items, freeGifts, removeCount, loading, isOpen, checkoutUrl, totalPrice } = useSelector(state => state.cart);
	const { translation, cartSettings: { bonus, upsell } } = useGlobalContext();

	const dispatch = useDispatch();

	const cartItems = Object.values(items);

	useEffect(() => {
		if (isOpen)
			checkoutUrl && trackViewCart({ items, totalPrice });
	}, [checkoutUrl]);

	const clearCart = async () => {
		if (loading) return;
		await dispatch(removeCartItems(cartItems.map(item => item?.tempId)));
		trackRemoveFromCart(cartItems);
	};

	// Sort the cart items so that the bonus product is always at the top
	const sortedItems = bonus?.product ? cartItems.sort((a, b) => {
		if (!a?.variant || !b?.variant) return 0;
		if (a.variant.id === bonus.product.variant.id) return -1;
		if (b.variant.id === bonus.product.variant.id) return 1;
		return 0;
	}) : cartItems;

	const { coreProducts, sideProducts } = getCartItemsSeparated(sortedItems);

	const sideItems = [...sideProducts, ...freeGifts];

	return (
		<>
			<div className="cart-body">
				{cartItems?.length > 0 ?
					<>
						<div className={"overflow-y-auto px-6 flex flex-col gap-y-5 my-3"}>
							{coreProducts.map(item => item?.id && <CartItem key={item.variant.id} product={item} />)}
							{sideItems.length > 0 && (
								<div className="border-t border-gray-200 pt-4">
									<p className="text-sm font-semibold mb-2">{translation.cart?.side_products}</p>
									<div className="flex flex-col gap-y-5">
										{sideItems.map(item => item?.id && <CartItem key={item.variant.id} product={item}
											onRemoved={() => onSideProductRemoved(item.variant.id)} />)}
									</div>
								</div>)}
						</div>
						<ClearCart removeCount={removeCount} onClick={clearCart} />
					</> :
					<EmptyCart />}
			</div>
			<CartUpsell config={upsell} items={items} />
		</>

	);
};

export default CartBody;